import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  AppBarTitleService,
  isLargeLoanProgramOffer,
  LargeLoanProgramBankIntegrationNotice,
  ApplicationOfferBundleData,
  OfferCalculatorService
} from 'common';
import { DomSanitizer } from '@angular/platform-browser';
import { AppSettings } from '../../../app.settings';
import { CurrencyPipe, PercentPipe } from '@angular/common';
import { ApplicationService } from '../application.service';
import { BaseCalculatorComponent } from '../../calculator/base/base-calculator.component';

@Component({
    selector: 'ifa-line-of-credit-content',
    templateUrl: './line-of-credit-content.component.html',
    styleUrls: ['./line-of-credit-content.component.scss'],
    standalone: false
})
export class LineOfCreditContentComponent extends BaseCalculatorComponent {

  isLargeLoanProgram: boolean;
  readonly bankIntegrationNotice = LargeLoanProgramBankIntegrationNotice;

  constructor(
    route: ActivatedRoute,
    sanitizer: DomSanitizer,
    appBarTitleService: AppBarTitleService,
    calculatorService: OfferCalculatorService,
    applicationService: ApplicationService,
    settings: AppSettings,
    percentPipe: PercentPipe,
    currencyPipe: CurrencyPipe
  ) {
    super(route, sanitizer, appBarTitleService, calculatorService, applicationService, settings, percentPipe, currencyPipe);
  }

  // Route data re-resolves the bundle when the applicant switches between LOC offers.
  dataInit(data: { preview: boolean; bundle: ApplicationOfferBundleData }): void {
    super.dataInit(data);
    this.isLargeLoanProgram = isLargeLoanProgramOffer(this.bundle);
  }
}
